import { UserQuestionsTypes } from './userEnums';
import { SaferGamblingQuestionTextMap } from './userInterfaces';

export const closeAccountReasons = [
  {
    textId: 'profile.close_account.not_happy_product',
    id: 14,
  },
  {
    textId: 'profile.close_account.not_happy_service',
    id: 4,
  },
  {
    textId: 'profile.close_account.not_happy_promotions',
    id: 13,
  },
  {
    textId: 'profile.close_account.not_gamble',
    id: 15,
  },
  // {
  //   textId: 'profile.close_account.other', // removed for v1 of the web-app
  //   id: 16
  // },
];

export const EMPLOYMENT_DETAILS_MIN_INPUT_LENGTH = 2;

export const MAX_DOCUMENTS_TO_UPLOAD = 3;

export const SAFER_GAMBLING_QUESTION_TYPES: UserQuestionsTypes[] = [
  UserQuestionsTypes.RESPONSIBLE_GAMBLING_SET_1,
  UserQuestionsTypes.RESPONSIBLE_GAMBLING_SET_2,
];

export const QUESTION_TEXT_MAP_BY_SET: {
  [key: number]: SaferGamblingQuestionTextMap;
} = {
  [UserQuestionsTypes.RESPONSIBLE_GAMBLING_SET_1]: {
    lieOrHide: 'profile.verification.safer_gambling.lie_or_hide',
    someoneElsesMoney: 'profile.verification.safer_gambling.someone_else_money',
    chaseLosses: 'profile.verification.safer_gambling.chase_losses',
    notInControl: 'profile.verification.safer_gambling.not_in_control',
  },
  [UserQuestionsTypes.RESPONSIBLE_GAMBLING_SET_2]: {
    loseTrackOfTime: 'profile.verification.safer_gambling.lose_time_track',
    gambleMoreThanIntended: 'profile.verification.safer_gambling.more_than_intended',
    irritation: 'profile.verification.safer_gambling.irritated',
    gambleInstead: 'profile.verification.safer_gambling.gamble_instead',
  },
};
